import { Outlet } from 'react-router-dom';

export function AuthLayout(): JSX.Element {
  return (
    <div className="min-h-screen bg-bg">
      <Outlet />
    </div>
  );
}
